import React, { Fragment, useEffect, useContext, useState } from "react";
import { TextsContext } from '../../context/textsContext';
import Stylegeneral from "../../scss/general.module.scss";
import { TitleH1Component } from "../../components/TitleH1Component";
import style from '../../scss/tabla.module.scss';
import styleForm from '../../scss/form.module.scss';
import { useCotizador } from "../../context/apiContext";
import ModalEnvioEmailComponent from "../../components/ModalEnvioEmailComponent";
import { useFeeTable } from "../../hooks/FeeTableHook";
import StyleBtn from "../../scss/btn.module.scss";
import { Icon } from "@iconify/react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DialogComponent from "../../components/DialogComponent";
import { ParagraphComponent } from "../../components/ParagraphComponent";
import { usePdf } from "../../hooks/PdfHook";
import { useNavigate } from "react-router-dom";
import { sendEmailWithPdf } from "../../api/emailApi";
import { useCotizacionAdapter } from "../../hooks/CotizadorAdapterHook";
import { TitleH3Component } from "components/TitleH3Component";
import { useAuth } from "context/userContext";
import { saveCotizador } from "../../api/cotizadorApi";
import { downloadPdfWithData } from "../../api/pdfGeneratorApi";
import { useCotizacionSaveAdapter } from "../../hooks/CotizadorSaveAdapterHook";
import Loader from "components/LoaderComponent";
import Stylestep8 from 'scss/step8.module.scss'
import Styleboton from "scss/btn.module.scss";
import { TitleH2Component } from "components/TitleH2Component";
import { CircularProgress } from "@mui/material";
import { isInFrame } from "../../helpers/toolsHelper";
import { scrollToTopNew } from "components/GlobalFunction";
import { convertMoneyAndTruncateOrRound, getQuoteId } from "components/utils/helper";
import { useCalculations } from "hooks/CalculationsHook";
import { transformData } from "components/utils/RequestQuoter.util";
import { updateContext } from "helpers/UpdateBenefitsContext";
import { quoter } from "api/feature/quoterApi";
import { useSteps } from "hooks/useSteps";
import Swal from "sweetalert2";
import { CalculationErrorBadge } from "components/CalculationErrorBadge";
import { useRecalculateQuote } from "hooks/useRecalculateQuote";

const Step9Pages = () => {
  const { texts, getCurrentLanguage, verifyCurrentLanguage } = useContext(TextsContext);
  const { contextState, timely, handleOnChange, email, calculationValue, addCalculation, addCalculationError, name, surname, coverage, calculationError } = useCotizador();
  const { calculateValue } = useCalculations();
  const { recalculate, isRecalculating } = useRecalculateQuote();
  const { getIncompleteModules } = useSteps();
  const [loading, setLoading] = useState(false);

  // Mismo chequeo que pinta la X "pendiente" en el sidebar (ver StepComponents.jsx):
  // si algún módulo previo quedó con campos obligatorios sin resolver (o las
  // casillas de aceptación de /step8 sin marcar), no se deja aplicar/guardar/
  // descargar desde acá - llegar a /step9 no exige haber completado el resto. El
  // detalle de qué falta ya lo muestra el sidebar - acá solo se bloquean los botones.
  const hasIncompleteSteps = getIncompleteModules().length > 0;
  // El último compute falló o todavía no hay un precio válido (ver
  // CalculationsHook/quoteFormState): aplicar/guardar acá dejaría al usuario con un
  // precio "legacy" respecto a los cambios más recientes del formulario.
  const hasValidPrice = +calculationValue?.data?.quotation?.totalPremiumWithFee > 0;
  const isPriceStale = calculationError || !hasValidPrice;
  const [showMessager, setShowMenssager] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const handleClose = () => setShowMenssager(false);
  const handleCloseSave = () => {
    setShowSave(false);
    window.location.href = '/home';
  }
  const { user } = useAuth();

  const [values] = useState({
    semiannual: texts?.step9_second_payment ?? "Second payment",
    quarterly: texts?.step9_2_3_4_payment ?? "2,3 and 4 payment",
    monthly: texts?.step9_other_payments ?? "Other payments"
  })

  const [valuesTotal] = useState({
    annual: texts?.general_table_title_total ?? 'Total',
    semiannual: texts?.step9_first_payment ?? "First payment",
    quarterly: texts?.step9_first_payment ?? "First payment",
    monthly: texts?.step9_first_payment ?? "First payment"
  })

  const { getPdfData, getPdfRefactorData } = usePdf();
  const { createApplication } = useCotizacionAdapter();
  const { getTotalMain, getPaymentDependent, hasSpouse, hasSon, getPaymentSpouse, getTotal, getAdminFee, getOtherPayments } = useFeeTable();
  const navigate = useNavigate();

  const customHandleOnChange = (e) => {
    handleOnChange(e)

    try {

      const newContext = updateContext(e, contextState)
      newContext.timely = e.target.value

      const reqQuoter = transformData(newContext, getCurrentLanguage(), null)

      quoter(reqQuoter)
        .then(response => {

          if (response && response !== undefined && response?.data !== null) {
            addCalculation(response)
          } else {
            addCalculationError()
          }

        })

    } catch (error) {
      console.error('Error fetching calculated value:', error)
      addCalculationError()
    }
  }

  useEffect(() => {
    verifyCurrentLanguage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApply = async () => {
    // Defensa adicional: el botón ya queda disabled (ver isNotActive), pero /step9 es
    // alcanzable por URL directa sin pasar por los steps previos, así que se repite el
    // chequeo acá antes de mandar la aplicación al back.
    if (hasIncompleteSteps || isPriceStale) return;

    setLoading(true);
    setShowMenssager(true);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 25000);

    try {
      const { last_inserted_application_id, last_inserted_quotation_id, url } = await Promise.race([
        createApplication(),
        new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 25000))
      ]);

      if (!last_inserted_application_id || !url) {
        throw new Error("invalid_response");
      }

      if (last_inserted_quotation_id) {
        await calculateValue(last_inserted_quotation_id);
      }

      await sendEmailWithPdf(
        { ...getPdfRefactorData(), to: email, applicationId: last_inserted_application_id, url },
        user
      );

      clearTimeout(timeout);
      setLoading(false);
      setShowMenssager(false);
      redirect(url);

    } catch (error) {
      clearTimeout(timeout);
      setLoading(false);
      setShowMenssager(false);

      let title = texts?.modal_error_title ?? "Error";
      let message = texts?.modal_error_default ?? "An unexpected error occurred. Please try again.";

      if (error.name === "AbortError" || error.message === "timeout") {
        title = texts?.modal_timeout_title ?? "Request Timeout";
        message = texts?.modal_timeout_message ?? "The request took too long. Please check your internet connection and try again.";
      }

      else if (error.message?.includes("Network Error")) {
        title = texts?.modal_network_title ?? "Network Error";
        message = texts?.modal_network_message ?? "Unable to connect to the server. Please verify your connection.";
      }

      else if (error.message === "invalid_response") {
        title = texts?.modal_response_title ?? "Invalid Server Response";
        message = texts?.modal_response_message ?? "The server returned an incomplete response. Please try again.";
      }

      else if (error.response) {
        title = texts?.modal_server_title ?? "Server Error";
        message = (error.response?.data?.message || texts?.modal_server_message) ?? "There was a problem processing your request.";
      }

      console.error("handleApply error:", error);

      Swal.fire({
        title,
        text: message,
        icon: "error",
        confirmButtonText: texts?.modal_button_ok ?? "OK"
      });
    }
  };


  const redirect = (url) => {
    if (!isInFrame()) {
      if (user.userId.toString() === "7783" || user.agentId.toString() === "10159") {
        window.location.href = url;
      } else {
        window.location.href = url;
      }
    } else {
      window.parent.postMessage({ url }, "*");
    }
    // navigate("/login-app");
  }

  const isNotActive = () => {
    return hasIncompleteSteps || isPriceStale;
  }

  const { createApplicationSave } = useCotizacionSaveAdapter();

  const handleSaveButton = () => {
    if (hasIncompleteSteps || isPriceStale) return;

    setLoading(true);
    saveCotizador(getPdfData())
      .then(({ data }) => {
        return createApplicationSave(data.id, getQuoteId(contextState));
      })
      .then(({ last_inserted_quotation_id }) => {
        if (last_inserted_quotation_id) {
          return calculateValue(last_inserted_quotation_id).then(() => last_inserted_quotation_id);
        }

        return last_inserted_quotation_id;
      })
      /* .then((last_inserted_quotation_id) => {
        return sendEmailWithPdf(
          { ...getPdfData(), to: email, applicationId: last_inserted_quotation_id, url: VUMI_LOGIN_URL },
          user
        );
      }) */
      .then(() => {
        setLoading(false);
        setShowSave(true);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  };

  const irInicio = () => {
    window.location.href = '/home'
  }

  const getCalculation = () => {
    /* if (fee.isFetching || fare.isFetching || fareDependant.isFetching || fareRider.isFetching) {
      return texts?.footer_value ?? 'Calculating...';
    } */
    const totalPremiumWithFee = +calculationValue?.data?.quotation?.totalPremiumWithFee || 0
    return convertMoneyAndTruncateOrRound(totalPremiumWithFee.toFixed(2));
  }
  const handlePdf = () => {
    if (loading) return;
    if (hasIncompleteSteps || isPriceStale) return;
    setLoading(true);

    downloadPdfWithData({ ...getPdfRefactorData() }, isInFrame())
      .finally(() => {
        setLoading(false);
      });
  }

  function scrollToTop() {
    navigate("/step8")
    scrollToTopNew();

  }
  return (
    <Fragment>
      <section className="mt-4" id="sectionscroll">
        <div className="container">
          <TitleH1Component styleGroup={`raleway_semibold fw_700  lh_30 color_primary pb-4 ${Stylegeneral.titulo}`}>
            {texts?.step9_title ?? "Here's the breakdown of your customized quote"}
          </TitleH1Component>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-7 col-xl-8 order-2 order-md-1 ">
              <div className="row">
                <div className="col-xl-10 offset-xl-2 text-end">
                  <div className="py-4 d-flex justify-content-between alignitems-center mx-sm-0 mx-2">
                    <div className="d-flex align-items-center">
                      <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1 `}>{texts?.step9_label_Payment_frequency ?? 'Payment_frequency'}</label>
                      <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={<Tooltip id="tooltip-top" className="custom-tooltip">
                          {texts?.step9_tooltip_Payment_frequency}
                        </Tooltip>}
                      >
                        <Icon icon={'mdi:information-outline'} className={` color_gray_5 ${styleForm.iconselect}`} />
                      </OverlayTrigger>
                    </div>
                    <div className={style.ContainerSelector}>
                      <select value={timely} onChange={customHandleOnChange} name="timely" className={style.sSelector} >
                        <option value="annual">{texts?.step9_radio_title_annual ?? 'Annual'}</option>
                        <option value="semiannual">{texts?.step9_radio_title_semiannual ?? 'Semi-Annual'}</option>
                        <option value="quarterly">{texts?.step9_radio_title_quarterly ?? 'Quarterly'}</option>
                      </select>
                    </div>

                  </div>
                </div>

                <div className="col-xl-10 offset-xl-2">
                  <div className={style.table_container}>

                    <div className={`${style.tabla_row} d-flex w-100  raleway`}>
                      <div className={`w-50 h-auto text-start ${style.tabla_cellstart}`}><span className="fw-bold">{texts?.general_table_title_main ?? 'Main Applicant'}</span></div>
                      <div className={`w-50 h-auto text-end ${style.tabla_cell}`}>{convertMoneyAndTruncateOrRound(getTotalMain()[timely])}</div>
                    </div>

                    {
                      (contextState.addDependant && hasSpouse()) && (
                        <div className={`${style.tabla_row} d-flex w-100  raleway`}>
                          <div className={`w-50 h-auto text-start ${style.tabla_cellstart}`}><span className="fw-bold">{texts?.general_form_option_spouse}</span></div>
                          <div className={`w-50 h-auto text-end ${style.tabla_cell}`}>{convertMoneyAndTruncateOrRound(getPaymentSpouse()[timely])}</div>
                        </div>
                      )
                    }

                    {
                      (contextState.addDependant && hasSon()) && (
                        <div className={`${style.tabla_row} d-flex w-100  raleway`}>
                          <div className={`w-50 h-auto text-start ${style.tabla_cellstart}`}><span className="fw-bold">{texts?.dependents_info_collapsible_title}</span></div>
                          <div className={`w-50 h-auto text-end ${style.tabla_cell}`}>{convertMoneyAndTruncateOrRound(getPaymentDependent()[timely])}</div>
                        </div>
                      )
                    }

                    <div className={`${style.tabla_row} d-flex w-100  raleway`}>
                      <div className={`w-50 h-auto text-start ${style.tabla_cellstart}`}><span className="fw-bold">{texts?.general_table_title_fee ?? 'Admin Fee'}</span></div>
                      <div className={`w-50 h-auto text-end ${style.tabla_cell}`}>{convertMoneyAndTruncateOrRound(getAdminFee()[timely])}</div>
                    </div>

                    <div className={`${style.tabla_row} d-flex w-100  raleway`}>
                      <div className={`w-50 h-auto text-start ${style.tabla_cellstart}`}><span className="fw-bold">{valuesTotal[timely]}</span></div>
                      <div className={`w-50 h-auto text-end ${style.tabla_cell}`}>{convertMoneyAndTruncateOrRound(getTotal()[timely])}</div>
                    </div>

                    {
                      values[timely] && (
                        <div className={`${style.tabla_row} d-flex w-100  raleway`}>
                          <div className={`w-50 h-auto text-start ${style.tabla_cellstart}`}><span className="fw-bold">{values[timely]}</span></div>
                          <div className={`w-50 h-auto text-end ${style.tabla_cell}`}>{convertMoneyAndTruncateOrRound(getOtherPayments()[timely])}</div>
                        </div>
                      )
                    }
                  </div>
                </div>
                <div className="col-xl-10 offset-xl-2 ">
                  <div className="d-flex justify-content-center mt-5 ">
                    <button
                      disabled={loading || hasIncompleteSteps || isPriceStale}
                      title={
                        hasIncompleteSteps
                          ? (texts?.step9_incomplete_tooltip ?? 'Complete all steps first')
                          : isPriceStale
                            ? (texts?.step9_stale_price_tooltip ?? 'Update the price before saving')
                            : undefined
                      }
                      type="button" className={`Poppins fw_500 color_primary px-4 me-2 ${Stylegeneral.vwbtn} ${StyleBtn.btn}`} onClick={handleSaveButton}>
                      <Icon icon="ant-design:save-outlined" className={`${StyleBtn.icono} me-2`} />
                      <span>{texts?.step9_share_pdf ?? "Save"}</span>
                    </button>
                    <button
                      disabled={(loading || isNotActive())}
                      title={
                        hasIncompleteSteps
                          ? (texts?.step9_incomplete_tooltip ?? 'Complete all steps first')
                          : isPriceStale
                            ? (texts?.step9_stale_price_tooltip ?? 'Update the price before applying')
                            : undefined
                      }
                      type="button" className={`Poppins fw_500 color_primary px-4 me-2 ${Stylegeneral.vwbtn} ${style.btnApply} ${StyleBtn.btn}`} onClick={() => { handleApply() }}>
                      <Icon icon="la:user-check" className={`${StyleBtn.icono} me-2`} />
                      <span>{texts?.step9_button_Apply_Now ?? 'Apply Now'}</span>
                    </button>
                  </div>

                  <div className="d-flex justify-content-center mt-5">
                    <button type="button" disabled={loading} className={`Poppins fw_500 px-4 me-2  ${StyleBtn.btnNeutro} ${Stylegeneral.vwbtn} ${StyleBtn.btn}`} onClick={scrollToTop}>
                      <span className="color_secundary">{texts?.footer_button_previous ?? 'Previous'}</span>
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <div className="col-12 col-md-5 col-xl-4 order-1 order-md-2">
              <div className={`${Stylestep8.tarjeta_info} mx-sm-0 mx-2`}>
                <TitleH3Component styleGroup="raleway_bold fw_700  color_primary mb-3 mb-md-2">
                  {texts?.step8_phrase_summary ?? 'Summary'}
                </TitleH3Component>
                <TitleH2Component styleGroup="raleway fw_400  color_secundary mb-2 ">
                  {name} {surname}
                </TitleH2Component>
                <TitleH3Component styleGroup=" pb-2 pb-md-0 ">
                  <span
                    className={`color_primary raleway_bold  ${Stylestep8.tama_subtitle}`}>{texts?.step8_phrase_date ?? 'Coverage Start Date'}</span>
                  <p

                    className={`${Stylestep8.tama_date}  raleway color_primary`}>{coverage}</p>
                </TitleH3Component>

                {loading ? <CircularProgress size={50} />
                  :
                  <button type="button" onClick={handlePdf}
                    disabled={hasIncompleteSteps || isPriceStale}
                    title={
                      hasIncompleteSteps
                        ? (texts?.step9_incomplete_tooltip ?? 'Complete all steps first')
                        : isPriceStale
                          ? (texts?.step9_stale_price_tooltip ?? 'Update the price before downloading')
                          : undefined
                    }
                    className={`${Styleboton.btn} d-flex align-items-center my-3 py-3 py-md-2 mb-1 ${Styleboton.btndescarga} w-100`}>
                    <Icon icon="prime:file-pdf" className={`${Stylestep8.icono}`} /> <span
                      className={`${Styleboton.text_boton} raleway`}>{texts?.step8_phrase_download ?? 'Download quote'}</span>
                  </button>
                }
                <hr className={`${Stylestep8.line}`} />
                <TitleH2Component styleGroup="raleway fw_400  color_primary_2 ">
                  {texts?.step8_phrase_cost ?? 'Estimated annual cost:'}
                </TitleH2Component>
                <TitleH1Component styleGroup={`raleway fw_600 color_secundary`}>
                  {getCalculation()}
                </TitleH1Component>
                {isPriceStale && (
                  <CalculationErrorBadge onRetry={recalculate} retrying={isRecalculating} variant="card" />
                )}
              </div>
            </div>

          </div>
        </div>
      </section>
      <ModalEnvioEmailComponent />


      <DialogComponent show={showMessager} onClose={handleClose}>
        <Icon icon="mdi:checkbox-marked-circle" width={40} height={40} style={{ color: '#61A60E' }} className="mb-3" />
        <TitleH2Component styleGroup="raleway fw_700 color_primary mb-2">
          {texts?.Modal_title_Apply ?? '¡Just one step to go!'}
        </TitleH2Component>
        <ParagraphComponent styleGroup="raleway color_primary mb-3">
          {texts?.modal_textTitle_Apply ?? '¡Just one step to go!'}
        </ParagraphComponent>
        <Loader Loaderpunto></Loader>
      </DialogComponent>

      <DialogComponent
        show={showSave}
        onClose={handleCloseSave}
        onConfirm={irInicio}
        confirmText={texts?.modal_button_understood ?? 'Entendido'}
      >
        <Icon icon="mdi:checkbox-marked-circle" width={40} height={40} style={{ color: '#61A60E' }} className="mb-3" />
        <TitleH2Component styleGroup="raleway fw_700 color_primary mb-0">
          {texts?.modal_textTitle_save ?? 'Se guardo con éxito '}
        </TitleH2Component>
      </DialogComponent>
    </Fragment>
  );
};

export default Step9Pages;
